<template>
  <div class="letter_wrap">
    <div class="red_top_bg">
      <div
        class="back_left"
        @click="$router.push('/user')"
      />
      <div class="big_tit">
        {{ $t('notice.message') }}
      </div>
    </div>
    <div class="msg_num">
      <!-- <div class="all_msg"><span>{{data.ok_read_num}}</span>{{$t('notice.unRead')}}</div>
			<div class="read">全部标为已读</div> -->
    </div>
    <div class="msg_box">
      <van-empty
        v-if="empty"
        :description="$t('orders.noOrders')"
      />
      <template v-if="!empty">
        <!-- @click="$router.push('/notice/'+item.id)" -->
        <div
          v-for="item in data.list"
          :key="item.id"
          class="item"
        >
          <p class="tips">
            <span>{{ noticeTitle(item) }}</span>
            <span
              v-if="item.is_new"
              class="new_badge"
            >{{ $t('notice.new') }}</span>
          </p>
          <div class="line" />
          <p class="time">
            {{ formatBrowserTime(item.add_time) }}
          </p>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
	import Vue from "vue";
	import {
		Empty
	} from "vant";
	
	import Fetch from "../../utils/fetch";
	Vue.use(Empty);
	export default {
		name: "Notice",
		data() {
			return {
				title:"title_"+ (this.$i18n.locale||"zh_cn"),
				content:"content_"+ (this.$i18n.locale||"zh_cn"),
				empty:false,
				data: {
					list: []
				},
			};
		},
		created() {
			this.$parent.footer('user',false);
		},
		mounted() {
			this.start();
		},
		methods: {
			start() {
				Fetch('/user/notice').then((r) => {
					const list = r.data.list || [];
					this.data = Object.assign({}, r.data, {
						list
					});
					list.length == 0 ?
						(this.empty = true) :
						(this.empty = false);
				});
			},
			noticeTitle(item) {
				return item[this.title] || item.title || item[this.content] || item.content || "";
			},
		}
	};
</script>

<style lang="less" scoped>
	.letter_wrap {
		min-height: 100vh;
		padding-top: 60px;
		padding-bottom: 78px;
		background: #F4F5FA;
		box-sizing: border-box;
	}

	.red_top_bg {
		height: 50px;
		background: #F4F5FA;
		position: fixed;
		top: 0;
		left: 50%;
		transform: translateX(-50%);
		z-index: 15;
	}

	.big_tit {
		font-size: 16px;
		font-weight: 400;
		line-height: 50px;
		color: #132235;
		height: 50px;
		text-align: center;
		position: relative;
		top: 0;
	}

	.back_left {
		width: 44px;
		height: 44px;
		margin: 0;
		position: absolute;
		top: 0;
		left: 0;
		background: none;
		z-index: 1000;
		&::before {
			content: "";
			width: 11px;
			height: 11px;
			border-left: 2px solid #071528;
			border-bottom: 2px solid #071528;
			position: absolute;
			top: 15px;
			left: 17px;
			transform: rotate(45deg);
		}
	}

	.msg_num {
		display: none;
	}

	.msg_box {
		width: 100%;
		padding: 0 13px;
		box-sizing: border-box;

		.item {
			width: 100%;
			min-height: 100px;
			margin-bottom: 8px;
			padding: 15px 14px 12px;
			border-radius: 5px;
			background: #FFFFFF;
			box-sizing: border-box;
			overflow: hidden;
		}

		.tips {
			min-height: 48px;
			font-size: 14px;
			font-weight: 400;
			line-height: 24px;
			color: #06182B;
			word-break: break-word;

			.new_badge {
				display: inline-block;
				margin-left: 8px;
				padding: 0 5px;
				border-radius: 9px;
				background: #ff1724;
				color: #fff;
				font-size: 10px;
				line-height: 18px;
				vertical-align: 1px;
			}
		}

		.line {
			height: 1px;
			margin-top: 6px;
			border-bottom: 1px dashed #DADDE5;
		}

		.time {
			margin-top: 7px;
			font-size: 12px;
			font-weight: 400;
			line-height: 18px;
			color: #5D6F84;
		}
	}
</style>
